import * as Sentry from "@sentry/browser";
import StreamPlayer from "../AudioPlayer/StreamPlayer"
import { get, includes, isEmpty } from "lodash";
import * as React from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { Button } from "react-toolbox/lib/button";
import Snackbar from "react-toolbox/lib/snackbar";
import Tooltip from "react-toolbox/lib/tooltip";
import BespokenDownloadIcon from "../../../assets/bespoken_download_icon_2.svg";
import BespokenGearIcon from "../../../assets/bespoken_gear_icon_2.svg";
import BespokenPowerIcon from "../../../assets/bespoken_power_icon.svg";
import BespokenSaveIcon from "../../../assets/bespoken_save_icon.svg";
import SpinnerImg from "../../../assets/spinner.svg";
import { setLoading } from "../../actions/loading";
import {
    addAssertion, addInteraction, addTest, cloneTest, deleteAssertion, deleteTest, getSource, removeInteraction, reorderTest, resultsInit, resultsPending, resultsUpdate, resultsUpdateAllPendingStatus, resultsUpdateInteractionAllStatus, saveSource, updateAssertionAction,
    updateAssertionOperator,
    updateAssertionValue, updateConfig, updateConfigNested, updateInteractionInput, updateInterimResults, updateMeta, updateMonitoringSchedule, updateName, updateOnlyFlag, updateSkipFlag, updateTestName,
    updateTestSuiteDescription,
    updateYaml,
    updateYamlObject, validateYamlSyntax
} from "../../actions/source";
import { TestResultStatus } from "../../constants";
import YamlHelper from "../../helpers/yaml-helper";
import BespokenUser from "../../models/bespoken-user";
import { Source } from "../../models/source";
import { State } from "../../reducers";
import { VirtualDevices } from "../../reducers/organization";
import BespokenApi, { BESPOKEN_API_WS_URL, BESPOKEN_API_MEDIA_URL, fetchBespokenApi } from "../../services/bespoken-api";
import { updateReportResultsProjectName } from "../../services/bespoken-reporting-api";
import * as Intercom from "../../services/intercom";
import WebsocketClient from "../../services/websocket-client";
import { Cell } from "../Grid/index";
import { IconLabelButton } from "../IconLabelButton/IconLabelButton";
import { BespokenModal } from "../Modal/BespokenModal";
import ReactDiv from "../ReactDiv";
import { SwitchLabel } from "../SwitchLabel/SwitchLabel";
import TypeImage from "../TypeImage/TypeImage";
import { InplaceEditor, Line } from "../lunacy";
import { HasPrivilege } from "../lunacy/privileges/HasPrivileges";
import { MonitoringModal, SCHEDULE_TYPES } from "./monitoring-modal";
import { SourceHeader } from "./sections/source-header";
import SourceSettings from "./sections/source-settings";
import TestEditor from "./sections/test-editor";
import TestList from "./sections/test-list";
import TestResults from "./sections/test-results";
import YamlEditor from "./sections/yaml-editor";
import { CurrentPageProps } from "../../reducers/context";
import { setCurrentPageProps } from "../../actions/context";
import { fetchInternalApi } from "../../services/internal-api";
import { wrapCallbackAsAsync } from "../../utils/ReactHelpers";
import { email } from "../PlatformIcons/PlatformIcons";
const globalWindow: any = typeof (window) !== "undefined" ? window : {};


const InlineEditInput = require("riek").RIEInput;

const TooltipDiv = Tooltip(ReactDiv);

const theme = require("../../themes/autosuggest.scss");
const inputTheme = require("../../themes/input.scss");
const tooltipTheme = require("../../themes/tooltip.scss");
const bespokenButton = require("../../themes/bespoken_button.scss");
const validationStyle = require("../validation/ValidationParentComponentStyle.scss");
const smallSwitchTheme = require("../../themes/small-switch-theme.scss");
const sourceStyle = require("./source-style.scss");

interface OwnProps {
    sourceId: string;
}

interface SourceProps {
    source: Source;
    interimResults: string[];
    testResults: any;
    hasUnsavedChanges: boolean;
    finishLoading: boolean;
    loading: boolean;
    syntaxError: string;
    getSource: (userId: string, sourceId: string) => Promise<Source>;
    saveSource: (name: string, sourceId: string, yaml: any, config: any, meta: any, monitoringConfig: any) => Promise<any>;
    getTestResults: () => any;
    goTo: (path: string) => (dispatch: any) => void;
    updateConfig: (property: string, value: string) => void;
    updateConfigNested: (property: string, value: string) => void;
    updateMeta: (property: string, value: any) => Promise<any>;
    updateYaml: (value: any) => Promise<any>;
    updateName: (value: string) => Promise<any>;
    updateYamlObject: (value: any) => void;
    addTest: (name: string) => void;
    cloneTest: (index: number) => void;
    deleteTest: (index: number) => void;
    updateTestName: (testIndex: number, name: string) => void;
    updateSkipFlag: (testIndex: number, value: boolean) => void;
    updateOnlyFlag: (testIndex: number, value: boolean) => void;
    addInteraction: (testIndex: number, interactionIndex?: number) => void;
    removeInteraction: (testIndex: number, interactionIndex: number) => void;
    updateInteractionInput: (testIndex: number, interactionIndex: number, input: string) => void;
    addAssertion: (testIndex: number, interactionIndex: number) => void;
    deleteAssertion: (testIndex: number, interactionIndex: number, itemIndex: number) => void;
    updateAssertionAction: (testIndex: number, interactionIndex: number, itemIndex: number, value: string) => void;
    updateAssertionOperator: (testIndex: number, interactionIndex: number, itemIndex: number, value: string) => void;
    updateAssertionValue: (testIndex: number, interactionIndex: number, itemIndex: number, value: string) => void;
    resultsInit: (yamlObject: any, testIndex: number | number[], status: string) => Promise<any>;
    resultsPending: (yamlObject: any) => Promise<any>;
    resultsUpdateInteractionAllStatus: (testIndex: number, interactionIndex: number, status: string) => void;
    resultsUpdate: (testIndex: number, interactionIndex: number, conversationId: string, path: string, value: any) => void;
    validateYamlSyntax: (yaml: string) => void;
    resultsUpdateAllPendingStatus: (testIndex: number, status: string) => void;
    setLoading: (value: boolean) => void;
    updateMonitoringSchedule: (cron: string, emailsToNotify: string) => any;
    updateInterimResults: (results: string[]) => void;
    reorderTest: (oldIndex: number, newIndex: number) => void;
    virtualDevices: VirtualDevices[];

    userId: string;

    updateTestSuiteDescription: (description: string) => void;
    organizationId: string;
    setCurrentPageProps: (value: CurrentPageProps) => any;

}

function mapStateToProps(state: State.All, ownProps: OwnProps) {
    return {
        source: state.sourceGit.currentSource,
        sourceId: ownProps.sourceId,
        interimResults: state.sourceGit.interimResults,
        testResults: state.sourceGit.testResults,
        hasUnsavedChanges: state.sourceGit.hasUnsavedChanges,
        finishLoading: state.sourceGit.finishLoading,
        loading: state.loading.loading,
        syntaxError: state.sourceGit.syntaxError,
        virtualDevices: state?.organization?.selectedOrganization?.virtualDevices,
        userId: state?.user?.currentUser?.id,
        organizationId: state?.organization?.selectedOrganization?.id,
    }
}

function mapDispatchToProps(dispatch: any) {
    return {
        getSource: (userId: string, sourceId: string): Promise<any> => {
            return wrapCallbackAsAsync(handle => dispatch(getSource(userId, sourceId, handle)));
        },
        saveSource: (name: string, sourceId: string, yaml: any, config: any, meta: any, monitoringConfig: any): any => {
            return dispatch(saveSource(name, sourceId, yaml, config, meta, monitoringConfig))
        },
        reorderTest: (oldIndex: number, newIndex: number): any => {
            return dispatch(reorderTest(oldIndex, newIndex))
        },
        goTo: function (path: string) {
            dispatch(push(path));
        },
        updateConfig: (property: string, value: string): any => {
            return dispatch(updateConfig(property, value));
        },
        updateConfigNested: (property: string, value: string): any => {
            return dispatch(updateConfigNested(property, value));
        },
        updateMeta: (property: string, value: string): any => {
            return dispatch(updateMeta(property, value));
        },
        updateYaml: (value: any): any => {
            return dispatch(updateYaml(value));
        },
        updateName: (value: string): any => {
            return dispatch(updateName(value));
        },
        updateYamlObject: (value: any): any => {
            return dispatch(updateYamlObject(value));
        },
        addTest: function (name: string) {
            dispatch(addTest(name))
        },
        cloneTest: function (index: number) {
            dispatch(cloneTest(index))
        },
        deleteTest: function (index: number) {
            dispatch(deleteTest(index))
        },
        updateTestName: function (testIndex: number, name: string) {
            dispatch(updateTestName(testIndex, name))
        },
        updateInterimResults: function (interimResults: string[]) {
            dispatch(updateInterimResults(interimResults))
        },
        updateSkipFlag: function (testIndex: number, value: boolean) {
            dispatch(updateSkipFlag(testIndex, value))
        },
        updateOnlyFlag: function (testIndex: number, value: boolean) {
            dispatch(updateOnlyFlag(testIndex, value))
        },
        addInteraction: function (testIndex: number, interactionIndex?: number) {
            dispatch(addInteraction(testIndex, interactionIndex))
        },
        removeInteraction: function (testIndex: number, interactionIndex: number) {
            dispatch(removeInteraction(testIndex, interactionIndex))
        },
        updateInteractionInput: function (testIndex: number, interactionIndex: number, input: string) {
            dispatch(updateInteractionInput(testIndex, interactionIndex, input))
        },
        addAssertion: function (testIndex: number, interactionIndex: number) {
            dispatch(addAssertion(testIndex, interactionIndex))
        },
        deleteAssertion: function (testIndex: number, interactionIndex: number, itemIndex: number) {
            dispatch(deleteAssertion(testIndex, interactionIndex, itemIndex))
        },
        updateAssertionAction: function (testIndex: number, interactionIndex: number, itemIndex: number, value: string) {
            dispatch(updateAssertionAction(testIndex, interactionIndex, itemIndex, value))
        },
        updateAssertionOperator: function (testIndex: number, interactionIndex: number, itemIndex: number, value: string) {
            dispatch(updateAssertionOperator(testIndex, interactionIndex, itemIndex, value))
        },
        updateAssertionValue: function (testIndex: number, interactionIndex: number, itemIndex: number, value: string) {
            dispatch(updateAssertionValue(testIndex, interactionIndex, itemIndex, value))
        },
        resultsInit: function (yamlObject: any, testIndex: number | number[], status: string) {
            return dispatch(resultsInit(yamlObject, testIndex, status))
        },
        resultsPending: function (yamlObject: any) {
            return dispatch(resultsPending(yamlObject))
        },
        resultsUpdateInteractionAllStatus: function (testIndex: number, interactionIndex: number, status: string) {
            dispatch(resultsUpdateInteractionAllStatus(testIndex, interactionIndex, status))
        },
        resultsUpdate: function (testIndex: number, interactionIndex: number, conversationId: string, path: string, value: any) {
            dispatch(resultsUpdate(testIndex, interactionIndex, conversationId, path, value))
        },
        validateYamlSyntax: function (yaml: string) {
            dispatch(validateYamlSyntax(yaml))
        },
        resultsUpdateAllPendingStatus: function (testIndex: number, status: string) {
            dispatch(resultsUpdateAllPendingStatus(testIndex, status))
        },
        setLoading: (value: boolean) => {
            return dispatch(setLoading(value));
        },
        updateMonitoringSchedule: (cron: string, emailsToNotify: string): any => {
            return dispatch(updateMonitoringSchedule(cron, emailsToNotify));
        },
        updateTestSuiteDescription: (description: string) => dispatch(updateTestSuiteDescription(description)),
        setCurrentPageProps: (value: CurrentPageProps) => dispatch(setCurrentPageProps(value)),
    }
}

interface SourceState {
    showMessage: boolean;
    sourceName: string;
    selectedTestIndex: number;
    showSettings: boolean;
    isRunningAll: boolean;
    originalName: string;
    snackbarActive: boolean;
    snackbarLabel: string;
    conversationId: string;
    testRunning: boolean;

    monitoringModalIsVisible?: boolean;
    monitoringDisablingModalIsVisible?: boolean;
    monitoringIsChecked?: boolean;
    monitoringScheduleType?: string;

    canSetupMonitoring?: boolean;
    canEditSchedule?: boolean;
}

export class SourceComponent extends React.Component<SourceProps & OwnProps, SourceState> {
    socketClient: any;
    streamClient: any;
    constructor(props: SourceProps & OwnProps) {
        super(props);
        this.state = {
            showMessage: true,
            sourceName: '',
            selectedTestIndex: 0,
            showSettings: false,
            isRunningAll: false,
            originalName: '',
            snackbarActive: false,
            snackbarLabel: '',
            conversationId: '',
            monitoringIsChecked: false,
            monitoringModalIsVisible: false,
            monitoringDisablingModalIsVisible: false,
            testRunning: false
        };
    }

    onUnload = (e: any) => {
        e.preventDefault();
        console.log('onUnload hasUnsavedChanges ', this.props.hasUnsavedChanges)
        const confirmationMessage = 'Some message';
        e.returnValue = confirmationMessage;
        return confirmationMessage
    }

    componentDidMount() {
        this.props.setCurrentPageProps({ title: "", subTitle: "" })

        // console.log('componentDidMount SourceComponent')
        // window.addEventListener("beforeunload", this.onUnload);
        this.loadSource();
    }

    componentWillUnmount() {
        // window.removeEventListener("beforeunload", this.onUnload);
    }

    componentDidUpdate(prevProps: SourceProps & OwnProps) {
        // console.log('componentDidUpdate')
        if (prevProps.sourceId !== this.props.sourceId) {
            // console.log('componentDidUpdate loadSource')
            this.loadSource();
        }
    }

    loadSource = () => {
        // console.log('loadSource')
        this.props.setLoading(true);
        this.props.getSource(this.props.userId, this.props.sourceId)
            .then((result: any) => {
                const monitoringScheduleType = result?.monitoringConfig?.cron;
                const monitoringIsChecked = !isEmpty(monitoringScheduleType)
                const { yamlObject } = this.props.source;
                this.props.resultsInit(yamlObject, this.state.selectedTestIndex, TestResultStatus.INITIAL);
                this.setState(prevState => ({
                    ...prevState,

                    originalName: result?.meta?.name,
                    monitoringScheduleType,
                    monitoringIsChecked
                }));

                // Validate YAML when first entering the page in case there are errors
                if (this.props.source.meta.isYamlEditor) {
                    this.onValidateYamlSyntax()
                }
                this.props.setLoading(false)
            })

    }

    handleChangeSelectedTestIndex = (selectedTestIndex: number) => {
        this.setState(prevState => ({
            ...prevState,
            selectedTestIndex,
        }));
    }

    handleSourceNameChange = async (value: any) => {
        const prevName = get(this.props.source, 'name');
        const name = value.sourceName;
        if (!name) return;
        if (prevName === name) return;

        this.props.updateName(name)
            .then(() => {
                const projectId = this.props.source.config.projectId;
                const projectName = value.sourceName;
                const customerId = this.props.userId;
                updateReportResultsProjectName({ projectId, projectName, customerId });
            })
    }

    handleYamlChange = async (value: any) => {
        this.props.updateYaml(value)
    }

    handleShowSettings = () => {
        this.setState(prevState => ({
            ...prevState,
            showSettings: !prevState.showSettings,
        }));
    }

    handleSave = () => {
        this.props.setLoading(true);
        const { sourceId, userId, source } = this.props;
        const { yamlObject, config, meta, yaml, monitoringConfig, name } = source;
        const isYamlEditor = get(this.props.source, 'meta.isYamlEditor', false)

        const newMonitoringConfig = monitoringConfig?.cron === '??m' ? undefined : monitoringConfig;

        const yamlUpdated = isYamlEditor
            ? yaml
            : YamlHelper.toYaml(yamlObject);
        return this.props.saveSource(name, sourceId, yamlUpdated, config, meta, newMonitoringConfig)
            .then(() => this.props.setLoading(false))
            .catch(err => {
                this.setState({ snackbarLabel: 'There was an error while saving your test. Please review and try again.', snackbarActive: true })
                console.error(err)
                Sentry.captureException(err);
                this.props.setLoading(false)
            });
    }

    handleRun = async () => {
        console.info('run clicked')
        if (!this.validate()) return;
        // Clear any buffer on the stream player
        StreamPlayer.instance().reset()

        const lastRunDate = new Date().toISOString();
        globalWindow && Intercom.updateIntercom(globalWindow, {
            lastRunDate,
            company: {
                id: this.props.organizationId,
                lastRunDate,
            }
        });

        if (this.props.hasUnsavedChanges) {
            await this.handleSave();
        }

        const { yamlObject, config } = this.props.source;
        const { name: dashboardVoiceAppName } = this.props.source?.meta

        this.props.resultsInit(yamlObject, this.state.selectedTestIndex, TestResultStatus.PENDING);

        const yaml = YamlHelper.toYaml({
            tests: [{
                ...yamlObject.tests[this.state.selectedTestIndex],
                // remove skip and only flags when running by index
                skip: false,
                only: false,
            }]
        });

        return this.runScript(yaml, config, false, { meta: this.props.source.meta, dashboardVoiceAppName });
    }

    handleRunAll = async () => {
        if (!this.validate()) return;
        const lastRunDate = new Date().toISOString();
        globalWindow && Intercom.updateIntercom(globalWindow, {
            lastRunDate,
            company: {
                id: this.props.organizationId,
                lastRunDate,
            }
        });
        if (this.props.hasUnsavedChanges) {
            await this.handleSave();
        }
        const { yamlObject, config } = this.props.source;
        const { name: dashboardVoiceAppName } = this.props.source?.meta

        const onlyIndexes = yamlObject?.tests.reduce((acc: any, test: any, index: number) => {
            if (test.only) {
                acc.push(index);
            }
            return acc;
        }, []);
        const notSkipIndexes = yamlObject?.tests.reduce((acc: any, test: any, index: number) => {
            if (!test.skip) {
                acc.push(index);
            }
            return acc;
        }, []);
        const indexesToInit = onlyIndexes.length > 0
            ? onlyIndexes
            : notSkipIndexes
        // this.props.resultsPending(yamlObject);
        this.props.resultsInit(yamlObject, indexesToInit, TestResultStatus.PENDING);

        const yaml = YamlHelper.toYaml(yamlObject);

        this.runScript(yaml, config, true, { meta: this.props.source.meta, dashboardVoiceAppName });

    }

    handleCancel = async () => {
        console.info("cancel clicked")
        if (!this.socketClient) return;
        if (!this.state.conversationId) return;
        const platform = this.props.source?.config?.platform || "alexa";

        const payload = {
            action: 'stop',
            conversationId: this.state.conversationId,
            platform
        }
        this.socketClient.send(payload)
        const { yamlObject } = this.props.source;
        const { isRunningAll, selectedTestIndex } = this.state;
        const indexes = yamlObject?.tests.map((item: any, index: number) => {
            return index;
        });

        if (isRunningAll) {
            this.props.resultsInit(yamlObject, indexes, TestResultStatus.INITIAL);
        } else {
            this.props.resultsUpdateAllPendingStatus(selectedTestIndex, TestResultStatus.INITIAL)
        }

        this.postTestCleanup(undefined)
    }

    runScript = async (yaml: string, config: any, isRunningAll: boolean, context = {}) => {
        this.props.setLoading(true);
        this.setState(prevState => ({
            ...prevState,
            isRunningAll,
            conversationId: '',
            testRunning: true
        }));


        this.socketClient = new WebsocketClient().init(BESPOKEN_API_WS_URL, {
            onOpen: () => {
                this.socketClient.send({
                    action: 'runSuite',
                    yaml,
                    config: { ...config, client: 'dashboard' },
                    context: { ...context, userId: this.props.userId },
                });
            },
            onClose: () => {
                this.postTestCleanup(undefined)
            },
            onMessage: (message: any) => {
                try {
                    const payload = JSON.parse(message);
                    const { isRunningAll, selectedTestIndex } = this.state;

                    if (payload?.type === "result") {
                        const interactionResult = payload.body;
                        const { conversationId } = payload.body || {}

                        let hasError = false
                        for (let index = 0; index < interactionResult?.assertions?.length; index++) {
                            const assertion = interactionResult.assertions[index];
                            const testIndex = isRunningAll ? interactionResult.testIndex : selectedTestIndex;
                            const actual = interactionResult?.result?.error
                                ? interactionResult.result.error.message
                                : assertion?.actual
                            const error = interactionResult?.result?.error?.message
                            hasError = error !== undefined
                            this.props.resultsUpdate(testIndex, interactionResult.relativeIndex, conversationId, assertion?.path, {
                                actual: actual,
                                error: error,
                                path: assertion?.path,
                                passed: assertion?.passed,
                                status: TestResultStatus.COMPLETED,
                            });
                            console.info('on result has error: ' + hasError)

                        }

                        if (hasError) {
                            this.postTestCleanup(0)
                        }
                    } else if (payload?.type === "onTestSuiteEnd") {
                        this.postTestCleanup(selectedTestIndex)

                    } else if (payload?.type === "onInterimResults") {
                        //console.info('get interim results')
                        this.props.updateInterimResults(payload.interimResults)

                    } else if (payload?.type === "conversationId") {
                        this.props.setLoading(false);

                        // Start streaming audio from the server if this is a phone call
                        if (!this.streamClient && this.props.source?.config?.platform === 'phone') {
                            this.openMediaSocket(payload.conversationId)
                        }
                        this.setState(prevState => ({
                            ...prevState,
                            conversationId: payload.conversationId,
                        }));
                    }

                } catch (error) {
                    console.log(error)
                }
            }
        });

    }

    openMediaSocket (conversationID: string) {
        const playback = StreamPlayer.instance().play()
        this.streamClient = new WebsocketClient().init(BESPOKEN_API_MEDIA_URL + '/' + conversationID, {
            onMessage: (message: any) => {
                //console.info("received streaming data from server: " + message.length)
                playback.pushBlob(message)
            },
            onOpen: () => {
                //console.info("socket opened")
            }
        });
    }

    postTestCleanup (index: number) {
        if (index) {
            this.props.resultsUpdateAllPendingStatus(index, TestResultStatus.COMPLETED)
        }

        // Reset the interim results
        this.props.updateInterimResults([])

        if (this.socketClient) {
            this.socketClient.close();
            this.socketClient = undefined
        }

        if (this.streamClient) {
            this.streamClient.close();
            this.streamClient = undefined
        }

        this.props.setLoading(false);
        this.props.updateInterimResults([])
        this.setState(prevState => ({
            ...prevState,
            conversationId: '',
            testRunning: false
        }));
    }

    validate = () => {
        const platform = this.props.source?.config?.platform || "alexa";
        const phoneNumber = this.props.source?.config?.phoneNumber;
        const selectedIndex = this.state.selectedTestIndex;
        const interactions = this.props.source?.yamlObject?.tests.length
            && this.props.source?.yamlObject?.tests[selectedIndex]
            && this.props.source?.yamlObject?.tests[selectedIndex]?.interactions;

        if (["phone", "twilio", "sms", "whatsapp"].indexOf(platform) > -1) {
            if (!phoneNumber) {
                this.handleShowSnackbar("The phone number is required.");
                return false;
            } else {
                const numberRegex = new RegExp(/^\+?[1-9]\d{1,14}$/);
                const isValidNumber = numberRegex.test(phoneNumber);
                if (!isValidNumber) {
                    this.handleShowSnackbar("The phone number is invalid. Please enter a valid US number or follow the E.164 format.");
                    return false;
                }
            }
        }

        for (const interaction of interactions) {
            if (!interaction.input) {
                this.handleShowSnackbar(`Remove empty input`);
                return false;
            }
            for (const item of interaction.items) {
                if (!item.action) {
                    this.handleShowSnackbar(`Remove empty assertion at interaction: ${interaction.input}`);
                    return false;
                }
                if (!item.value) {
                    this.handleShowSnackbar(`Remove empty assertion at interaction: ${interaction.input}`);
                    return false;
                }
            }
        }
        return true;
    }

    handleShowSnackbar = (label?: any) => {
        this.setState(prevState => ({
            ...prevState,
            snackbarLabel: label,
            snackbarActive: true
        }));
    }

    handleSnackbarClick = () => {
        this.setState({ ...this.state, snackbarActive: false });
    }

    handleYamlEditorChange = async () => {
        const isYamlEditor = get(this.props.source, 'meta.isYamlEditor', false);
        let { yamlObject, yaml } = this.props.source;
        await this.props.updateMeta('isYamlEditor', !isYamlEditor)
        if (!isYamlEditor) {
            yaml = YamlHelper.toYaml(yamlObject);
            await this.props.updateYaml(yaml);
        } else {
            const response: any = await BespokenApi.toYamlObject(yaml)
            await this.props.updateYamlObject(response);
        }

        // if (this.props.hasUnsavedChanges) {
        //     this.handleSave();
        // }
    }

    onValidateYamlSyntax = () => {
        const { yaml } = this.props.source;
        this.props.validateYamlSyntax(yaml);
    }

    downloadSource = async () => {
        const { sourceId } = this.props;
        try {
            // const blobResponse = await fetchBespokenApi(({ userId, organizationId }) => `/users/${userId}/organizations/${organizationId}/sources/${sourceId}/download`, 'GET')
            const blobResponse = await fetchInternalApi(({ userId, organizationId }) =>
                `/users/${userId}/organizations/${organizationId}/testsuites/${sourceId}/download`, 'GET')
            const downloadUrl = window.URL.createObjectURL(blobResponse);
            const link = document.createElement('a');
            const defaultFilename = `${this.props?.source?.name}.e2e.zip`;
            link.href = downloadUrl;
            link.setAttribute('download', defaultFilename);
            link.setAttribute('style', 'display: none;');
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (err) {
            console.error(err)
        }
    }

    render() {
        let isYamlEditor = get(this.props.source, 'meta.isYamlEditor', false)

        const loadingValidationResults = this.props.testResults?.some((testResult: any) => {
            //console.info('validation results: ' + JSON.stringify(testResult, null, 2))
            return testResult?.interactions?.some((interaction: any) => {
                return interaction?.items?.some((item: any) =>
                    item.status === TestResultStatus.PENDING)
            })
        });

        const virtualDevices = this.props?.virtualDevices || [];
        return (
            <form className={validationStyle.fix_mdl} style={{ position: "relative", top: "-60px", zIndex: 200 }}>
                <HasPrivilege onPrivilegesLoaded={privileges => {
                    this.setState({
                        canSetupMonitoring: includes(privileges, "can-use-monitoring"),
                        canEditSchedule: includes(privileges, "can-edit-schedule"),
                    })
                }} />
                <Cell col={12} tablet={12}>
                    <div className={sourceStyle.page_header_section}>
                        <div className={sourceStyle.test_suite_icon}>
                            <div>
                                <TypeImage platform={this.props.source?.config?.platform} />
                            </div>
                        </div>
                        <div className={sourceStyle.test_suite_title} data-intercom-target="SuiteTitle">
                            <div className={sourceStyle.title_input}>
                                <InlineEditInput className={inputTheme.validation_page}
                                    classEditing={inputTheme.validation_page_edit}
                                    propName={"sourceName"}
                                    value={this.props.source?.name || this.props.source?.meta?.name || ''}
                                    editProps={{ maxLength: 50 }}
                                    change={this.handleSourceNameChange}
                                />
                            </div>
                            <div className={validationStyle.test_suite_description}>
                                <InplaceEditor
                                    lines={1}
                                    saveOnBlur={true}
                                    maxLength={200}
                                    truncateLength={80}
                                    placeHolder={"Enter a test suite description..."}
                                    value={this.props?.source?.meta?.testSuiteDescription}
                                    onChanged={suiteDescription => this.props?.updateTestSuiteDescription(suiteDescription)}
                                    tooltip={this.props?.source?.meta?.testSuiteDescription}
                                />
                            </div>
                        </div>
                        <div className={sourceStyle.test_suite_attributes}>
                            <SourceHeader
                                source={this.props.source}
                                virtualDevices={virtualDevices}
                                updateConfig={this.props.updateConfig}
                                saveSource={this.handleSave}
                                hasUnsavedChanges={this.props.hasUnsavedChanges}
                                showSnackbarMessage={this.handleShowSnackbar}
                            />
                        </div>
                        <div className={sourceStyle.test_suite_actions}>
                            <SwitchLabel
                                label="YAML Editor"
                                tooltipText="The YAML Editor is a more powerful, advanced way of creating end to end tests. Learn more at https://read.bespoken.io"
                                checked={isYamlEditor}
                                onChange={this.handleYamlEditorChange}
                                size="small"
                            />
                            <SwitchLabel
                                label="Monitoring"
                                tooltipText={this.state?.canSetupMonitoring ?
                                    "Enable Monitoring and get notified instantly when there is a change in your tests results over time." :
                                    "Enable monitoring and get notified instantly when there is a change in your tests results over time. Available for Professional and Enterprise plans."
                                }
                                checkedTooltipText={this.getSelectedScheduleTypeLabel()}
                                disabled={!this.state?.canSetupMonitoring}
                                checked={this.state.monitoringIsChecked}
                                onChange={(selected: any) => this.onSwitchChange(selected)}
                                size="small"
                            />
                            <IconLabelButton
                                icon={<BespokenDownloadIcon />}
                                label="Download"
                                size="medium"
                                gap="12px"
                                onClick={this.downloadSource}
                            />
                            <IconLabelButton
                                icon={<BespokenGearIcon />}
                                label="Advanced"
                                size="medium"
                                gap="12px"
                                onClick={this.handleShowSettings}
                            />
                        </div>
                    </div>

                </Cell>
                <Cell col={12} tablet={12} style={{ height: '20px', display: "grid", alignItems: "center" }}>
                    <Line />
                </Cell>
                {isYamlEditor ? (
                    <Cell className={validationStyle.main_container} col={12} >
                        <TestResults
                            source={this.props.source}
                            testResults={this.props.testResults}
                            validateYamlSyntax={this.onValidateYamlSyntax}
                            syntaxError={this.props.syntaxError}
                        />
                        <YamlEditor
                            source={this.props.source}
                            handleYamlChange={this.handleYamlChange}
                        />
                    </Cell>
                ) : (
                    <Cell className={validationStyle.main_container} col={12} data-id="validation-interactions-script">
                        <TestList
                            source={this.props.source}
                            selectedTestIndex={this.state.selectedTestIndex}
                            updateTestName={this.props.updateTestName}
                            updateOnlyFlag={this.props.updateOnlyFlag}
                            updateSkipFlag={this.props.updateSkipFlag}
                            addTest={this.props.addTest}
                            deleteTest={this.props.deleteTest}
                            cloneTest={this.props.cloneTest}
                            handleChangeSelectedTestIndex={this.handleChangeSelectedTestIndex}
                            reorderTest={this.props.reorderTest}
                            loadingValidationResults={loadingValidationResults}
                            testResults={this.props.testResults}
                            handleRunAll={this.handleRunAll}
                        />
                        <TestEditor
                            source={this.props.source}
                            interimResults={this.props.interimResults}
                            testResults={this.props.testResults}
                            addInteraction={this.props.addInteraction}
                            removeInteraction={this.props.removeInteraction}
                            updateInteractionInput={this.props.updateInteractionInput}
                            addAssertion={this.props.addAssertion}
                            deleteAssertion={this.props.deleteAssertion}
                            updateAssertionAction={this.props.updateAssertionAction}
                            updateAssertionOperator={this.props.updateAssertionOperator}
                            updateAssertionValue={this.props.updateAssertionValue}
                            loadingValidationResults={loadingValidationResults}
                            selectedTestIndex={this.state.selectedTestIndex}
                        >
                            <div className={sourceStyle.new_visual_editor}>
                                {this.props.hasUnsavedChanges &&
                                    <span className={sourceStyle.warning_message}>You have unsaved changes</span>
                                }

                                <Button
                                    icon={<BespokenSaveIcon />}
                                    data-id="skill-save-button"
                                    id={"visual_save_button"}
                                    theme={bespokenButton}
                                    disabled={loadingValidationResults}
                                    type="button"
                                    onClick={this.handleSave}
                                    primary={true}>
                                    <span>Save</span>
                                </Button>
                                <Button
                                    icon={this.state.testRunning ? <SpinnerImg data-id={"img-status"} /> : <BespokenPowerIcon />}
                                    data-id="skill-run-button"
                                    theme={bespokenButton}
                                    accent={true}
                                    disabled={loadingValidationResults && !this.state.conversationId}
                                    className={`${bespokenButton.large} ${this.state.testRunning ? sourceStyle.cancel : ""}`}
                                    onClick={loadingValidationResults ? this.handleCancel : isYamlEditor ? this.handleRunAll : this.handleRun}
                                    data-intercom-target="RunTest"
                                >
                                    {loadingValidationResults || this.state.testRunning ?
                                        (
                                            <span>Cancel</span>
                                        ) :
                                        (
                                            <span>Run</span>
                                        )
                                    }
                                </Button>
                            </div>
                        </TestEditor>

                    </Cell>
                )}
                {isYamlEditor &&
                    <div className={sourceStyle.new_visual_editor}>
                        {this.props.hasUnsavedChanges &&
                            <span className={sourceStyle.warning_message}>You have unsaved changes</span>
                        }

                        <Button
                            icon={<BespokenSaveIcon />}
                            data-id="skill-save-button"
                            id={"visual_save_button"}
                            theme={bespokenButton}
                            disabled={loadingValidationResults}
                            type="button"
                            onClick={this.handleSave}
                            primary={true}>
                            <span>Save</span>
                        </Button>
                        <Button
                            icon={loadingValidationResults ? <SpinnerImg data-id={"img-status"} /> : <BespokenPowerIcon />}
                            data-id="skill-run-button"
                            theme={bespokenButton}
                            accent={true}
                            disabled={loadingValidationResults && !this.state.conversationId}
                            className={`${bespokenButton.large} ${loadingValidationResults ? sourceStyle.cancel : ""}`}
                            onClick={loadingValidationResults ? this.handleCancel : isYamlEditor ? this.handleRunAll : this.handleRun}
                        >
                            {loadingValidationResults ?
                                (
                                    <span>Cancel</span>
                                ) :
                                (
                                    <span>Run</span>
                                )
                            }
                        </Button>
                    </div>
                }
                <SourceSettings
                    source={this.props.source}
                    showSettings={this.state.showSettings}
                    handleShowSettings={this.handleShowSettings}
                    updateConfig={this.props.updateConfig}
                    updateConfigNested={this.props.updateConfigNested}
                    getConfig={() => this.props.source.config}
                    saveSource={this.handleSave}
                    hasUnsavedChanges={this.props.hasUnsavedChanges}
                />
                <Snackbar
                    className="sm-snackbar"
                    action="Dismiss"
                    type="cancel"
                    active={this.state.snackbarActive}
                    label={this.state.snackbarLabel}
                    timeout={10000}
                    onClick={this.handleSnackbarClick}
                    onTimeout={this.handleSnackbarClick}
                />
                <MonitoringModal
                    canEditSchedule={this.state.canEditSchedule}
                    showModal={this.state.monitoringModalIsVisible}
                    onCancel={async () => this.handleCancelMonitoring()}
                    onSuccess={async (cron, emailsToNotify) => this.handleSaveMonitoring(cron, emailsToNotify)}
                    selectedScheduleType={this.state.monitoringScheduleType}
                />

                <BespokenModal showModal={this.state.monitoringDisablingModalIsVisible} dialogToggle={() => this.handleDisablingMonitoringCancel()} title="Warning">
                    <p style={{ textAlign: 'center' }}>
                        Are you sure you want to disable <strong>{this.state.sourceName} monitoring?</strong>
                    </p>
                    <div className={sourceStyle.monitoring_modal_disabling}>
                        <Button
                            data-id="source-selector-modal-cancel-action"
                            theme={bespokenButton}
                            onClick={() => this.handleDisablingMonitoringCancel()}>Cancel</Button>
                        <Button
                            data-id="source-selector-modal-delete-action"
                            theme={bespokenButton}
                            accent={true}
                            onClick={() => this.handleDisablingMonitoringOk()}>OK</Button>
                    </div>
                </BespokenModal>
            </form>
        );
    }

    getSelectedScheduleTypeLabel(): string {
        return 'Schedule: ' + this.props.source?.monitoringConfig?.cronExplained + ' Notify: ' + this.props.source?.monitoringConfig?.emailsToNotify;
    }

    async handleCancelMonitoring(): Promise<void> {
        const monitoringIsChecked = false;
        const monitoringModalIsVisible = false;
        this.setState(prevState => ({ ...prevState, monitoringIsChecked, monitoringModalIsVisible }))
    }

    async handleDisablingMonitoringCancel(): Promise<void> {
        const monitoringDisablingModalIsVisible = false;
        const monitoringIsChecked = true;
        this.setState(prevState => ({ ...prevState, monitoringDisablingModalIsVisible, monitoringIsChecked }))
    }

    async handleSaveMonitoring(cron: string, emailsToNotify: string): Promise<void> {
        const monitoringModalIsVisible = false;
        const monitoringIsChecked = true;
        this.setState(prevState => ({ ...prevState, cron, monitoringIsChecked, monitoringModalIsVisible }))
        this.props.updateMonitoringSchedule(cron, emailsToNotify)
            .then(() => {
                if (this.props.hasUnsavedChanges) {
                    this.handleSave();
                }
            });
    }

    onSwitchChange(monitoringIsChecked: any) {
        if (!monitoringIsChecked) {
            const monitoringDisablingModalIsVisible = true;
            this.setState(prevState => ({ ...prevState, monitoringDisablingModalIsVisible }));
            return;
        }
        const monitoringModalIsVisible = true;
        let { monitoringScheduleType } = this.state;
        this.setState(prevState => ({ ...prevState, monitoringIsChecked, monitoringModalIsVisible, monitoringScheduleType }));
    }

    handleDisablingMonitoringOk() {
        const monitoringIsChecked = false;
        const monitoringDisablingModalIsVisible = false;
        const monitoringScheduleType: any = ''

        this.props.updateMonitoringSchedule(monitoringScheduleType, undefined)
            .then(() => {
                if (this.props.hasUnsavedChanges) {
                    this.handleSave();
                }
            });
        this.setState(prevState => ({ ...prevState, monitoringIsChecked, monitoringDisablingModalIsVisible, monitoringScheduleType }))
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SourceComponent);
